import { Box, darken, lighten, Typography } from "@mui/material";

const NumberCircle = ({
    numero,
    size = 64,
    variant = 'default',
    children,
}: {
    numero: number | string;
    size?: number;
    variant?: 'default' | 'gold';
    children?: React.ReactNode;
}) => (
    <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={size}
        minWidth={size}
        height={size}
        position="relative"
        borderRadius="50%"
        sx={(theme) => ({
            background:
                variant === 'gold'
                    ? `radial-gradient(
              circle at top left,
              #F5D98B 0%,
              #D4AF37 55%,
              #A8822A 100%
            )`
                    : `radial-gradient(
              circle at top left,
              ${lighten(theme.palette.primary.main, 0.18)} 0%,
              ${theme.palette.primary.main} 55%,
              ${darken(theme.palette.primary.main, 0.08)} 100%
            )`,
            boxShadow: `
        0 4px 10px rgba(0,0,0,0.18),
        inset 0 1px 0 rgba(255,255,255,0.25)
      `,
        })}
    >
        <Typography
            fontWeight={700}
            color="white"
            fontSize={size * 0.5}
            sx={{
                textShadow: '0 1px 2px rgba(0,0,0,0.25)',
            }}
        >
            {numero}
        </Typography>
        {children}
    </Box>
);

export default NumberCircle;